import { type PaletteMode, createTheme } from '@mui/material'
import { paletteLight } from './light/palette-light'
import { paletteDark } from './dark/palette-dark'

const lightPalette = createTheme({
  palette: paletteLight,
}).palette

const darkPalette = createTheme({
  palette: paletteDark,
}).palette

/**
 * Internally used in our theme, but could also be used for react native integrations
 */
export const createPalette = (mode: PaletteMode) => (mode === 'light' ? lightPalette : darkPalette)
